'use client';

import { createSlice } from '@reduxjs/toolkit';
import constants from '../../constants';
import moment from "moment/moment";

const initialState = {
	trySubmit: false,
	tryDraft: false,
	listSubscription: { ...constants.defaultResponse },
	area: [],
	verifiedIds: {
		capelID: null,
		kK0ID: null,
		formulirID: null,
	},
	capelData: {
		id: null,
		userID: null,
		custNumber: '',
		idPelanggan: '',
		namaPerusahaan: '',
		picFirst: '',
		picLast: '',
		noHP: '',
		email: '',
		jabatan: '',
		kantorNegara: 'INDONESIA',
		kantorProvinsi: '',
		kantorKota: '',
		kantorDistrik: '',
		kantorSubDistrik: '',
		kantorAlamat: '',
		kantorNoTelp: '',
		kantorPostalCode: '',
		kantorBuilding: '',
		kantorFloor: '',
		kantorHouseName: '',
		kantorStreetName: '',
		kantorBlock: '',
		kantorHouseNumber: '',
		kantorRT: '',
		kantorRW: '',
		kantorType: '',
		kantorAdditionalInfo: '',
		kantorDescription: '',
		kantorCoordinateSource: '',
		kantorCoordinateLatitude: '',
		kantorStatusKepemilikan: '',
		kantorCoordinateLongitude: '',
		kantorPIC: '',
		kantorEmail: '',
		kantorJabatan: '',
		pabrikNegara: 'INDONESIA',
		pabrikProvinsi: '',
		pabrikKota: '',
		pabrikDistrik: '',
		pabrikSubDistrik: '',
		pabrikAlamat: '',
		pabrikNoTelp: '',
		pabrikPostalCode: '',
		pabrikBuilding: '',
		pabrikFloor: '',
		pabrikHouseName: '',
		pabrikStreetName: '',
		pabrikBlock: '',
		pabrikHouseNumber: '',
		pabrikRT: '',
		pabrikRW: '',
		pabrikType: '',
		pabrikAdditionalInfo: '',
		pabrikDescription: '',
		pabrikCoordinateSource: '',
		pabrikCoordinateLatitude: '',
		pabrikStatusKepemilikan: '',
		pabrikCoordinateLongitude: '',
		pabrikPIC: '',
		pabrikEmail: '',
		pabrikJabatan: '',
		longitude: '',
		latitude: '',
		jenisProduk: '',
		willingnessToPay: '',
		jarakPipaTerdekat: 0,
		bbExisting: '',
		bbSupplier: '',
		bbDayaListrik: 0,
		bbKonsumsiListrik: 0,
		sektorUsaha: '',
		jumlahKaryawan: 0,
		jumlahShift: 1,
		polaOperasiJamHari: 1,
		polaOperasiHariMinggu: 1,
		waktuBebanPuncakDari: '',
		waktuBebanPuncakKe: '',
		isActive: 1,
		createdBy: '',
		createdOn: moment().format('YYYY-MM-DD'),
		modifiedBy: '',
		modifiedOn: moment().format('YYYY-MM-DD'),
		satuanMataUang: '',
		passwordCapel: null,
		aktaPabrik: '',
		aktaPabrikNo: '',
		aktaPabrikTanggal: null,
		aktaKantor: '',
		aktaKantorNo: '',
		aktaKantorTanggal: null,
		pejabatTandaTangan: '',
		noRefPelanggan: '',
		unitDayaListrik: '',
		postalCode: '',
		npwp: '',
	},
	kk0Payload: {
		id: null,
		capelID: '',
		regionID: null,
		docNumber: '',
		produkLayanan: '',
		tujuanPenggunaan: '',
		tujuanPenggunaanLainnya: '',
		informasiTambahan: '',
		tanggalSurvei: null,
		pemberiData: '',
		petugasSurvei: '',
		docStatus: '',
		isActive: null,
		createdBy: '',
		createdOn: moment().format('YYYY-MM-DD'),
		modifiedBy: '',
		modifiedOn: moment().format('YYYY-MM-DD'),
		kebutuhanJasa: '',
		areaID: null,
		efisiensiDiharapkan: 0,
	},
	jenisProdukPayload: [
		{
			id: null,
			capelID: '',
			nama: '',
			jumlah: 0,
			harga: 0,
			isActive: 0,
			satuan: 'ton',
		},
	],
	bahanBakarExisting: [
		{
			id: null,
			capelID: '',
			nama: '',
			pemasok: '',
			isActive: 0,
		},
	],
	bahanPangsa: [
		{
			id: null,
			capelID: '',
			tableType: 'material',
			negara: 'Indonesia',
			persentase: 0,
			isActive: 0,
		},
		{
			id: null,
			capelID: '',
			tableType: 'material',
			negara: '',
			persentase: 0,
			isActive: 0,
		},
		{
			id: null,
			capelID: '',
			tableType: 'market',
			negara: 'Indonesia',
			persentase: 0,
			isActive: 0,
		},
		{
			id: null,
			capelID: '',
			tableType: 'market',
			negara: '',
			persentase: 0,
			isActive: 0,
		},
	],
	currentFuel: [
		{
			bahanBakar: {
				id: null,
				capelID: '',
				nama: '',
				kapasitasVolume: 0,
				kapasitasUnit: 'L',
				polaJamHari: 0,
				polaHariMinggu: 0,
				bahanBakar: 'LPG',
				harga: 0,
				penggunaanVolume: 0,
				penggunaanUnit: 'MMBtu',
				isActive: 0,
				unitHarga: 'IDR',
			},
			peralatan: {
				id: null,
				capelID: '',
				peralatan: '',
				jumlah: 0,
				kapasitasVolume: 0,
				kapasitasUnit: 'L',
				polaJam: 0,
				polaHari: 0,
				pemakaianVolume: 0,
				pemakaianUnit: 'MMBtu',
				isActive: 0,
				jamOperasi: 0,

			},
		},
	],
	equipmentForm: [
		{
			id: null,
			formulirID: null,
			nama: '',
			jumlah: 0,
			kapasitas: 0,
			jamOperasi: 0,
			pemakaianMaksimum: 0,
			isActive: 0,
		},
	],
	formulirAmandemen: {
		id: null,
		capelID: null,
		formulirID: null,
		product: '',
		subProduct: '',
		gasAvgUsagePlan: 0,
		penyebabAmandemen: '',
		pemberlakuanAmandemen: moment().format('YYYY-MM-DD'),
		createdBy: '',
		docStatus: '',
		modifiedBy: '',
	},
	formulirData: {
		id: null,
		capelID: null,
		regionID: null,
		docNumber: '',
		skemaPembayaran: '',
		levelHirarki: '',
		lokasiTitikSerah: '',
		tglPenyerahanGas: '',
		tempatPenyerahanGas: '',
		codeHargaGas: '',
		periode: '',
		startDate: '',
		endDate: '',
		basisKontrak: 'Monthly',
		docStatus: '',
		isActive: 0,
		createdBy: '',
		modifiedBy: '',
		pjbgType: '',
		layananTambahanNo: '',
		layananTambahanTgl: '',
		penyebabAmandemen: '',
		berlakuStart: '',
		berlakuEnd: '',
		areaID: '',
		penggunaanGasMaksimum: 0,
		unitGasMaksimum: 'MMBtu',
		penggunaanGasMinimum: 0,
		unitGasMinimum: 'MMBtu',
		penggunaanGasRataRata: 0,
		unitGasRataRata: 'MMBtu',
		statusBangunan: '',
		startDateEstimation: '',
		sektorKomersial: '',
		sektorIndustri: '',
		sektorTransportasi: '',
		peralatanPenggunaGas: '',
		peralatanPenggunaGasLainnya: '',
		// tekananOperasi: 0,
		gasMaksimumTambahan: 0,
		gasMinimumTambahan: 0,
		gasRataRataTambahan: 0,
		polaOperasiJamHariTambahan: '',
		polaOperasiHariMingguTambahan: '',
		tekananOperasiTambahan: 0,
		startDateAdditional: '',
		endDateAdditional: '',
		postalCodeInstallation: '',
		phoneInstallation: '',
		// ADDED WHEN DEVELOP DOC PREVIEW
		createdOn: '',
		// gasEquipmentDetails: [
		// 	{
		// 		formulirID: null,
		// 		isActive: 0,
		// 		startDate: null,
		// 		endDate: null,
		// 		penggunaanGasRataRata: 0,
		// 		unitGasRataRata: 'MMBtu',
		// 		penggunaanGasMinimum: 0,
		// 		unitGasMinimum: 'MMBtu',
		// 		penggunaanGasMaksimum: 0,
		// 		unitGasMaksimum: 'MMBtu',
		// 		polaOperasiJamHari: '',
		// 		polaOperasiHariMinggu: '',
		// 		tekananOperasi: 0,
		// 	},
		// ],
	},
	peralatan: [
		{
			id: null,
			formulirID: null,
			nama: '',
			jumlah: 0,
			kapasitas: 0,
			jamOperasi: 0,
			pemakaianMaksimum: 0,
			isActive: 1,
			// anomali used
			// penggunaanUnit: '',
			//new form mockup
			startDate: null,
			endDate: null,
			// penggunaanGasRataRata: 0,
			// unitGasRataRata: 'MMBtu',
			// unitGasMinimum: 'MMBtu',
			// unitGasMaksimum: 'MMBtu',
			// penggunaanGasMinimum: 0,
			// penggunaanGasMaksimum: 0,
			// polaOperasiJamHari: 1,
			// polaOperasiHariMinggu: 1,
			// tekananOperasi: 0,

			// missing type
			amandemenID: null,
			createdBy: null,
			modifiedBy: null,
			kapasitasUnit: '',
			createdOn: moment(),
			modifiedOn: moment(),
			rowStatus: 0
		},
	],
	peralatanKomersial: [
		{
			CapelID: null,
			kK0ID: null,
			formulirID: null,
			isActive: 0,
			startDate: moment().format('YYYY-MM-DD'),
			endDate: moment().add(1, 'days').format('YYYY-MM-DD'),
			penggunaanGasRataRata: 0,
			unitPenggunaanGasRataRata: 'MMBtu',
			unitPenggunaanGasMinimum: 'MMBtu',
			unitPenggunaanGasMaksimum: 'MMBtu',
			penggunaanGasMinimum: 0,
			penggunaanGasMaksimum: 0,
			polaOperasiJamHari: 1,
			polaOperasiHariMinggu: 1,
			tekananOperasi: 0,
		},
	],
	validations: {
		valid: false,
		data: null,
		errors: {}
	}
};

export const subscriberData = createSlice({
	name: 'subscriberData',
	initialState,
	reducers: {
		addArea: (state, action) => {
			state.area = action.payload;
		},
		addListSubscription: (state, action) => {
			state.listSubscription = action.payload;
		},
		changekk0Payload: (state, action) => {
			state.kk0Payload = action.payload;
		},
		changeJenisProdukPayload: (state, action) => {
			state.jenisProdukPayload = action.payload;
		},
		changeBahanBakarExistingPayload: (state, action) => {
			state.bahanBakarExisting = action.payload;
		},
		changeBahanPangsaPayload: (state, action) => {
			state.bahanPangsa = action.payload;
		},
		changeCurrentFuelPayload: (state, action) => {
			state.currentFuel = action.payload;
		},
		changeEquipmentForm: (state, action) => {
			state.peralatan = action.payload;
		},
		changeFormulir: (state, action) => {
			state.formulirData = action.payload;
		},
		changeCapel: (state, action) => {
			state.capelData = action.payload;
		},
		changeTrySubmit: (state, action) => {
			state.trySubmit = action.payload;
		},
		changeTryDraft: (state, action) => {
			state.tryDraft = action.payload;
		},
		changePeralatanKomersial: (state, action) => {
			state.peralatanKomersial = action.payload;
		},
		changeValidations: (state, action) => {
			state.validations = action.payload;
		},
	},
});

export const {
	addArea,
	changekk0Payload,
	changeJenisProdukPayload,
	changeBahanBakarExistingPayload,
	changeBahanPangsaPayload,
	changeCurrentFuelPayload,
	changeFormulir,
	changeEquipmentForm,
	addListSubscription,
	changeCapel,
	changeTrySubmit,
	changeTryDraft,
	changePeralatanKomersial,
	changeValidations
} = subscriberData.actions;

export default subscriberData.reducer;
